/*jslint browser: true, nomen: true */
/*global $ */

/*!
 * classie v1.0.1
 * class helper functions
 * from bonzo https://github.com/ded/bonzo
 * MIT license
 * 
 * classie.has( elem, 'my-class' ) -> true/false
 * classie.add( elem, 'my-new-class' )
 * classie.remove( elem, 'my-unwanted-class' )
 * classie.toggle( elem, 'my-class' )
 */

 /*jshint browser: true, strict: true, undef: true, unused: true */
 /*global define: false, module: false */

 ( function( window ) {

  'use strict';

// class helper functions from bonzo https://github.com/ded/bonzo

function classReg( className ) {
  return new RegExp("(^|\\s+)" + className + "(\\s+|$)");
}



// classList support for class management
// altho to be fair, the api sucks because it won't accept multiple classes at once
var hasClass, addClass, removeClass;

if ( 'classList' in document.documentElement ) {
  hasClass = function( elem, c ) {
    return elem.classList.contains( c );
  };
  addClass = function( elem, c ) {
    elem.classList.add( c );
  };
  removeClass = function( elem, c ) {
    elem.classList.remove( c );
  };
}
else {
  hasClass = function( elem, c ) {
    return classReg( c ).test( elem.className );
  };
  addClass = function( elem, c ) {
    if ( !hasClass( elem, c ) ) {
      elem.className = elem.className + ' ' + c;
    }
  };
  removeClass = function( elem, c ) {
    elem.className = elem.className.replace( classReg( c ), ' ' );
  };
}

function toggleClass( elem, c ) {
  var fn = hasClass( elem, c ) ? removeClass : addClass;
  fn( elem, c );
}

var classie = {
  // full names
  hasClass: hasClass,
  addClass: addClass,
  removeClass: removeClass,
  toggleClass: toggleClass,
  // short names
  has: hasClass,
  add: addClass,
  remove: removeClass,
  toggle: toggleClass
};

// transport
if ( typeof define === 'function' && define.amd ) {
  // AMD
  define( classie );
} else if ( typeof exports === 'object' ) {
  // CommonJS
  module.exports = classie;
} else {
  // browser global
  window.classie = classie;
}

})( window );


'use strict';
function init() {
  window.addEventListener('scroll', function(e){
    var distanceY = window.pageYOffset || document.documentElement.scrollTop,
    shrinkOn = 300,
    header = document.querySelector("header");
    if (distanceY > shrinkOn) {
      classie.add(header,"smaller");
    } else {
      if (classie.has(header,"smaller")) {
        classie.remove(header,"smaller");
      }
    }
  });
}
window.onload = init();

function PageTimer() {
  var self = this;
  this.getLoadTime = function () {
    var now = new Date().getTime();
    // Get the performance object
    window.performance = window.performance || window.mozPerformance || window.msPerformance || window.webkitPerformance || {};
    var timing = performance.timing || {};

    var ms = now - timing.navigationStart;

    return Math.round(ms / 10) / 100;
  };

  this.logToConsole = function () {
    $(window).on('load', function () {
      console && console.info && console.info("Client loaded in " + self.getLoadTime() + 's');
    });
  };

  this.append = function (holder) {
    $(window).on('load', function () {
      holder.text(' | LT: ' + self.getLoadTime() + 's');
    });
  }
}


function StickyFooter($wrap, $footer) {
  var $window = $(window);
  this.updateWrapperCSS = function () {
    var footerHeight = $footer.outerHeight();

    $wrap.css({
      marginBottom: -1 * footerHeight,
      paddingBottom: footerHeight
    });
  };

  this.bindOnResize = function () {
    $window.on('resize', this.updateWrapperCSS);

    return this;
  };

  this.update = function () {
    this.updateWrapperCSS();

    return this;
  }
}



$('body')
.on('click', 'div.three button.btn-search', function(event) {
  event.preventDefault();
  var $input = $('div.three input');
  $input.focus();
  if ($input.val().length() > 0) {
      // submit form
    }
  })
.on('click', 'div.four button.btn-search', function(event) {
  event.preventDefault();
  var $input = $('div.four input');
  $input.focus();
  if ($input.val().length() > 0) {
      // submit form
    }
  })
.on('click', 'div.five button.btn-search', function(event) {
  event.preventDefault();
  var $input = $('div.five input');
  $input.focus();
  if ($input.val().length() > 0) {
      // submit form
    }
  })
.on('click', 'div.six button.btn-search', function(event) {
  event.preventDefault();
  var $input = $('div.six input');
  $input.focus();
  if ($input.val().length() > 0) {
      // submit form
    }
  })
.on('click', 'div.thirteen button.btn-search', function(event) {
  event.preventDefault();
  var $input = $('div.thirteen input');
  $input.focus();
  if ($input.val().length() > 0) {
      // submit form
    }
  })
.on('click', 'div.fourteen button.btn-search', function(event) {
  event.preventDefault();
  var $input = $('div.fourteen input');
  $input.focus();
  if ($input.val().length() > 0) {
      // submit form
    }
  });
/*
 Ensure all external links load as new window/tabs:
 */


 function ExternalLinkHandler() {
  var self = this;
  var hostname = document.location.hostname;

  this.matchInternalLink = [new RegExp("^https?:\/\/(.*?)" + hostname)];

  this.addTargetAttribute = function (context) {
    context.find('a').filter('[href^="http://"], [href^="https://"]').each(function () {
      var anchor = $(this);
      var href = anchor.attr('href');
      var isInternalLink = false;

      for (var i = 0; i < self.matchInternalLink.length; i++) {
        var regex = self.matchInternalLink[i];
        if (href.match(regex)) {
          isInternalLink = true;
        }
      }

      if (!isInternalLink) {
        anchor.attr('target', '_blank').addClass('external-link');
      }
    });
  };

}

function UIBindings() {
  this.bindTooltips = function () {
    $('[data-toggle="tooltip"]').tooltip();
  };
  this.bindPopovers = function () {
    $('[data-toggle="popover"]').popover();
  };

  this.bindSlickCarousels = function () {
    $('[data-slick-carousel-default]').slick({
      dots: true,
      slidesToShow: 1,
      //speed:300,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      autoplay:true,
      autoplayspeed:1000
    });

    $('[data-toggle="slick-nav"]').on('click', function (e) {
      e.preventDefault();
      var index = $(this).data('index');
      $('[data-slick-carousel-default]').slick('slickGoTo', index);
    });
  };

  this.wowSlide = function () {
    wow = new WOW({
      animateClass:'animated',

    });
    wow.init();
  };

  this.relatedCarousel = function () {
    $('.multiple-items').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      dots: true,
      responsive: [
      {
        breakpoint: 1005,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
      ],  

    });
    $('#personal-insurance-new').slick({
      dots: true,
      slidesToShow: 1,
      //speed:300,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      autoplay:true,
      autoplayspeed:3000
    });

    $('#business-insurance-new').slick({
      dots: true,
      slidesToShow: 1,
      //speed:300,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      autoplay:true,
      autoplayspeed:3000
    });
    $('#engineering-insurance-new').slick({
      dots: true,
      slidesToShow: 1,
      //speed:300,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      autoplay:true,
      autoplayspeed:3000
    });

    $('#specialised-insurance-new').slick({
      dots: true,
      slidesToShow: 1,
      //speed:300,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      autoplay:true,
      autoplayspeed:3000
    });


  };

  this.bindSharing = function () {
    $("[data-share-default]").each(function () {
      var shareHandler = new ShareHandler($(this));
      shareHandler.appendFacebook();
      shareHandler.appendTwitter();
      shareHandler.appendGoogle();
      //shareHandler.appendLinkedIn();
      //shareHandler.appendPinterest();
    });
  };

  this.bindMagnificpopup = function(){
    $('[data-magnific-gallery]').magnificPopup({
     type: 'image',
     callbacks:
     {
      markupParse: function(template, values, item)
      {
        values.description = item.el.data('description');
      }
    },
    gallery:{
      enabled:true
    },

    image:
    {
      headerFit: true,
      captionFit: true,
      preserveHeaderAndCaptionWidth: false,
      markup:
      '<div class="mfp-figure">'+
      '<figure>'+
      '<header class="mfp-header">'+
      '<div class="mfp-top-bar">'+
      '<div class="mfp-title"></div>'+
      '<div class="mfp-close"></div>'+
      '<div class="mfp-decoration"></div>'+
      '</div>'+
      '</header>'+
      '<section class="mfp-content-container">'+
      '<div class="mfp-img"></div>'+
      '</section>'+
      '<footer class="mfp-footer">'+
      '<figcaption class="mfp-figcaption">'+
      '<div class="mfp-bottom-bar-container">'+
      '<div class="mfp-bottom-bar">'+
      '<div class="mfp-counter"></div>'+
      '<div class="mfp-description"></div>'+
      '<div class="mfp-decoration"></div>'+
      '</div>'+
      '</div>'+
      '</figcaption>'+
      '</footer>'+
      '</figure>'+
      '</div>',
    }
  });
  };

  this.jumpTo = function () {

   // $('.nav-pills li a')
 }

 this.bindMasonary = function () {

  $('[data-masonry-default]').masonry({
    itemSelector: '[data-masonry-default] > div',
    columnWidth: '.grid-sizer'
  });
}

this.bindSubmittingButtons = function () {
  $(document).on('submit', function () {
    var submitText = $(this).find('[data-submit-text]');
    var submittingText = $(this).find('[data-submitting-text]');
    var btn = submitText.closest('button');
    submittingText.removeClass('hide');
    submitText.hide();
    btn.prop('disabled', true);
  });
};

}

function Notifications () {
  var wrapper = $('#notifications-wrapper');
  var div = $('#notifications');
  var wrapperTop = wrapper.offset().top;

  this.bindOnScroll = function () {
    wrapper.height(wrapper.height());
    $(window).on('scroll', function () {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > wrapperTop) {
        div.addClass('fixed');
      } else {
        div.removeClass('fixed');
      }
    })
  };

  this.bindCloseButton = function () {
    $(document).on('click', '[data-toggle="remove"]', function (e) {
      e.preventDefault();
      var notification = $(this).closest('.notification');
      notification.fadeOut(250, function () {
        wrapper.height('auto');
        wrapper.height(wrapper.height());

      });
    });
  };

  this.init = function () {
    this.bindOnScroll();
    this.bindCloseButton();
  };
}

$(function () {

  (new StickyFooter($('#container'), $('#footer'))).update().bindOnResize();

  (new ExternalLinkHandler).addTargetAttribute($('body'));

  (new PageTimer).logToConsole();

  (new UIBindings).bindTooltips();

  (new UIBindings).bindPopovers();

  (new UIBindings).relatedCarousel();
  
  (new UIBindings).wowSlide();

  (new UIBindings).jumpTo();

  (new UIBindings).bindSlickCarousels();

  (new UIBindings).bindSharing();

  (new UIBindings).bindMasonary();

  (new UIBindings).bindMagnificpopup();

  (new UIBindings).bindSubmittingButtons();

  (new Notifications).init();
});
$(function() {
  
          // Javascript to enable link to tab
          var hash = document.location.hash;
          // console.log(hash);

          //  if (window.location.hash == '#business-insurance') {
          //   alert('#business-insurance');
          // }else if(window.location.hash == '#personal-insurance'){
          //   alert('#personal-insurance');
          // }
          
          if (hash) {
            //console.log(hash);

            var aTag = $('.nav-tabs a[href='+hash+']');
            var slideTo = aTag.data('slideTo');

            aTag.tab('show');

            if(hash == '#business-insurance') {

             $('.sickty-right').css('display','block');

           } else {
            $('.sickty-right').css('display','none');
          }
          $('#myCarousel').carousel(slideTo);
          
          $('.carousel').carousel({
            interval: 100
          })
          console.log(slideTo);

          setTimeout(function(){
            $('html,body').animate({scrollTop: aTag.offset().top},'slow');
          }, 3);


        }

          // Change hash for page-reload
          $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
            window.location.hash = e.target.hash;

            if(window.location.hash == '#business-insurance') {

             $('.sickty-right').css('display','block');

           } else {
            $('.sickty-right').css('display','none');
          }

        }).on('shown.bs.tab', function(e){
          $('#myCarousel').on('slide.bs.carousel', function () {
            e.preventDefault();
            setTimeout(function(){
              $('#personal-insurance-new').slick('slickGoTo', -1);
              $('#business-insurance-new').slick('slickGoTo', -1);
              $('#engineering-insurance-new').slick('slickGoTo', -1);
              $('#specialised-insurance-new').slick('slickGoTo', -1);
            }, 10);

          });

        });
      });

$('.image_center').mouseenter(function(){

  var who =  '#div_' + this.id;
  var other =  '#icon_' + this.id;

  var image_icon = $(other);
  var imageCenter =  $(who);

  $(imageCenter).css("height","100px");
  $(imageCenter).fadeIn(1000);
  $(image_icon).css("display","none");

  if (!imageCenter.length) {
    return;
  }
  
  var svgData = {};
  svgData[imageCenter.attr('id')] = {

    "strokepath": [{
      "path": imageCenter.data('path'),
      "duration": 2000
    }, ],
    "dimensions": {
      "width": 240,
      "height": 220
    }
  };

  imageCenter.lazylinepainter({
    'svgData': svgData,
    'strokeWidth': 3,
    'strokeColor': '#1f5aa6',
    'drawSequential': true,
    'ease': 'easeInOutQuad',
  });

  setTimeout(function(){
    imageCenter.lazylinepainter('paint');
  })


  'use strict';

  ;( function ( document, window, index )
  {
    var inputs = document.querySelectorAll( '.inputfile' );
    Array.prototype.forEach.call( inputs, function( input )
    {
      var label  = input.nextElementSibling,
      labelVal = label.innerHTML;

      input.addEventListener( 'change', function( e )
      {
        var fileName = '';
        if( this.files && this.files.length > 1 )
          fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
        else
          fileName = e.target.value.split( '\\' ).pop();

        if( fileName )
          label.querySelector( 'span' ).innerHTML = fileName;
        else
          label.innerHTML = labelVal;
      });

    // Firefox bug fix
    input.addEventListener( 'focus', function(){ input.classList.add( 'has-focus' ); });
    input.addEventListener( 'blur', function(){ input.classList.remove( 'has-focus' ); });
  });
  }( document, window, 0 ));
});

protect_email = function (user_email) {
    var avg, splitted, part1, part2;
    splitted = user_email.split("@");
    part1 = splitted[0];
    avg = part1.length / 2;
    part1 = part1.substring(0, (part1.length - avg));
    part2 = splitted[1];
    return '...' + "...@" + part2;
};

protect_email("info@reefinsurance.co.za");



